<template>
  <div class="first-screen">
    <Parallax class="bg" :speed-factor="0.25" breakpoint="(min-width: 300px)">
      <img src="../assets/img/liubov-ilchuk-746545-unsplash.jpg" alt="">
    </Parallax>
    <div class="wrap">
      <div class="text">
        <h2>Dubai Cafe -</h2>
        <h1>Це чудова їжа</h1>
        <div class="line"></div>
        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est nihil sed magnam eius sunt vero nobis sint exercitationem omnis voluptates.</p>
        <form>
          <a href="#" type="button">Контакти</a>
          <a href="#" type="button">Ми на карті</a>
        </form>
      </div>
      <button class="scroll-down">&dArr;</button>
    </div>
    <About/>
  </div>
</template>

<script>
  import Parallax from "vue-parallaxy";
  import About from './About.vue';

  export default {
    name: 'FirstScreen',

    components: {
      Parallax,
      About
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../assets/styles/variables.scss";

  .first-screen{
    width: 100%;
    height: auto;
    text-align: center;
    color: #fff;
    position: relative;
    z-index: 1000;
    margin-top: 0;
    float: left;

    @media screen and (max-width: 768px) {
      height: auto;
    }

    .bg{
      width: 100%;
      height: 100% !important;
      min-height: 640px;
      z-index: -1;
      position: absolute;
      filter: brightness(40%);
    }
  }

  .text{
    height: 640px;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @media screen and (max-width: 768px) {
      height: auto;
      padding: 80px 0 120px;
    }

    h1{
      z-index: 900;
    }

    h2{
      font-weight: 600px;
    }

    .line{
      width: 100px;
      height: 2px;
      background-color: $accentColor;
      margin-top: 20px;
    }

    p{
      display: inline-block;
      width: 600px;
      margin-top: 40px;

      @media screen and (max-width: 768px) {
         width: 100%;
      }
    }

    form{
      display: inline-block;
      width: auto;
      height: auto;
      margin-top: 30px;
      white-space: nowrap;

      br{
        display: none;

        @media screen and (max-width: 768px) {
          display: block;
        }
      }

      a{
        display: inline-block;
        color: #fff;
        border: 2px solid #fff;
        background-color: rgba(0, 0, 0, 0.1);
        padding: 10px 20px;
        text-decoration: none;
        margin-left: 20px;
        backdrop-filter: blur(4px);
        transition: 0.2s;
      }

      a:hover{
        backdrop-filter: blur(3px);
        padding: 10px 25px;
        transition: 0.6s;
      }

      a:first-child{
        margin-left: 0;
      }

      a:last-child{
        margin-top: 10px;
      }
    }
  }

  .scroll-down{
    display: block;
    width: 60px;
    height: 60px;
    background-color: $accentColor;
    border: 0;
    position: absolute;
    bottom: -30px;
    left: calc(50% - 30px);
    border-radius: 30px;
    font-size: 24px;
    color: #fff;
    font-weight: bold;
    cursor: pointer;
    z-index: 1000;
  }
</style>
